/* Northline collection filters: Season, Shade, Fullness, Price, Availability + sort.
   Instant, client-side, state kept in the URL (?shade=lighter,medium&sort=price-asc). */
if (!customElements.get('nl-collection')) {
  class NlCollection extends HTMLElement {
    connectedCallback() {
      this.groups = ['season', 'shade', 'fullness', 'price', 'availability'];
      this.state = {};
      this.cards = Array.from(this.querySelectorAll('.nl-card'));
      this.grid = this.querySelector('[data-grid]');
      this.drawer = this.querySelector('[data-drawer]');
      this.drawerBody = this.querySelector('[data-drawer-body]');
      this.panel = this.querySelector('[data-pill-panel]');
      this.sortSelect = this.querySelector('[data-sort]');
      const source = this.querySelector('[data-groups-source]');
      if (source) this.drawerBody.append(...Array.from(source.children));
      this.groups = this.groups.filter((g) => this.drawerBody.querySelector('[data-group="' + g + '"]'));
      this.readUrl();
      this.bind();
      this.render();
    }

    readUrl() {
      const params = new URLSearchParams(window.location.search);
      this.groups.forEach((g) => {
        const v = params.get(g);
        this.state[g] = v ? v.split(',').filter(Boolean) : [];
      });
      this.sort = params.get('sort') || 'featured';
      if (this.sortSelect) this.sortSelect.value = this.sort;
    }

    writeUrl() {
      const params = new URLSearchParams(window.location.search);
      this.groups.forEach((g) => {
        if (this.state[g].length) params.set(g, this.state[g].join(','));
        else params.delete(g);
      });
      if (this.sort !== 'featured') params.set('sort', this.sort);
      else params.delete('sort');
      const q = params.toString();
      window.history.replaceState(null, '', window.location.pathname + (q ? '?' + q : '') + window.location.hash);
    }

    bind() {
      this.addEventListener('change', (e) => {
        const input = e.target;
        if (input.matches('[data-sort]')) {
          this.sort = input.value;
          this.render();
          return;
        }
        const group = input.closest('[data-group]');
        if (!group || input.type !== 'checkbox') return;
        const g = group.dataset.group;
        const set = new Set(this.state[g]);
        if (input.checked) set.add(input.value);
        else set.delete(input.value);
        this.state[g] = Array.from(set);
        this.render();
      });

      this.addEventListener('click', (e) => {
        const pill = e.target.closest('[data-pill]');
        if (pill) {
          this.togglePanel(pill);
          return;
        }
        if (e.target.closest('[data-open-drawer]')) {
          this.openDrawer();
          return;
        }
        if (e.target.closest('[data-close-drawer]')) {
          this.closeDrawer();
          return;
        }
        if (e.target.closest('[data-clear]')) {
          this.groups.forEach((g) => (this.state[g] = []));
          this.render();
          return;
        }
        const chip = e.target.closest('[data-chip]');
        if (chip) {
          const g = chip.dataset.chipGroup;
          this.state[g] = this.state[g].filter((v) => v !== chip.dataset.chip);
          this.render();
        }
      });

      document.addEventListener('click', (e) => {
        if (!this.panel || this.panel.hidden) return;
        if (e.target.closest('[data-pill-panel]') || e.target.closest('[data-pill]')) return;
        this.closePanel();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        this.closePanel();
        this.closeDrawer();
      });
    }

    togglePanel(pill) {
      const g = pill.dataset.pill;
      if (!this.panel.hidden && this.panel.dataset.group === g) {
        this.closePanel();
        return;
      }
      const original = this.drawerBody.querySelector('[data-group="' + g + '"]');
      if (!original) return;
      const clone = original.cloneNode(true);
      this.panel.innerHTML = '';
      this.panel.appendChild(clone);
      this.panel.dataset.group = g;
      this.panel.hidden = false;
      this.panel.style.left = pill.offsetLeft + 'px';
      this.querySelectorAll('[data-pill]').forEach((p) => p.setAttribute('aria-expanded', String(p === pill)));
      this.syncInputs();
    }

    closePanel() {
      if (!this.panel || this.panel.hidden) return;
      this.panel.hidden = true;
      this.panel.innerHTML = '';
      this.querySelectorAll('[data-pill]').forEach((p) => p.setAttribute('aria-expanded', 'false'));
    }

    openDrawer() {
      this.closePanel();
      this.drawer.hidden = false;
      document.body.classList.add('nl-drawer-open');
      requestAnimationFrame(() => this.drawer.classList.add('is-open'));
      this.querySelector('[data-open-drawer]').setAttribute('aria-expanded', 'true');
    }

    closeDrawer() {
      if (!this.drawer || this.drawer.hidden) return;
      this.drawer.classList.remove('is-open');
      document.body.classList.remove('nl-drawer-open');
      this.querySelector('[data-open-drawer]').setAttribute('aria-expanded', 'false');
      setTimeout(() => (this.drawer.hidden = true), 250);
    }

    matches(card, except) {
      return this.groups.every((g) => {
        if (g === except || !this.state[g].length) return true;
        return this.state[g].includes(card.dataset[g]);
      });
    }

    labelFor(g, v) {
      const input = this.drawerBody.querySelector('[data-group="' + g + '"] input[value="' + v + '"]');
      if (!input) return v;
      const label = input.closest('label').querySelector('.nl-check__label');
      return label ? label.childNodes[0].textContent.trim() : v;
    }

    syncInputs() {
      this.querySelectorAll('[data-group]').forEach((fs) => {
        const g = fs.dataset.group;
        fs.querySelectorAll('input[type="checkbox"]').forEach((input) => {
          input.checked = this.state[g].includes(input.value);
          const n = this.cards.filter((c) => this.matches(c, g) && c.dataset[g] === input.value).length;
          const label = input.closest('label');
          const count = label.querySelector('.nl-check__count');
          if (count) count.textContent = '(' + n + ')';
          label.classList.toggle('is-disabled', n === 0 && !input.checked);
          input.disabled = n === 0 && !input.checked;
        });
      });
    }

    render() {
      const visible = this.cards.filter((c) => this.matches(c, null));
      const sorted = visible.slice().sort((a, b) => {
        const soldA = a.dataset.availability === 'sold-out' ? 1 : 0;
        const soldB = b.dataset.availability === 'sold-out' ? 1 : 0;
        if (soldA !== soldB) return soldA - soldB;
        if (this.sort === 'price-asc') return a.dataset.price - b.dataset.price || a.dataset.index - b.dataset.index;
        if (this.sort === 'price-desc') return b.dataset.price - a.dataset.price || a.dataset.index - b.dataset.index;
        if (this.sort === 'newest') return b.dataset.created - a.dataset.created;
        return a.dataset.index - b.dataset.index;
      });
      this.cards.forEach((c) => (c.hidden = true));
      sorted.forEach((c) => {
        c.hidden = false;
        this.grid.appendChild(c);
      });

      const n = visible.length;
      const countEl = this.querySelector('[data-count]');
      if (countEl) countEl.textContent = n + (n === 1 ? ' trim' : ' trims');
      const drawerCount = this.querySelector('[data-drawer-count]');
      if (drawerCount) drawerCount.textContent = n;
      const empty = this.querySelector('[data-empty]');
      if (empty) empty.hidden = n > 0;

      let active = 0;
      const chips = [];
      this.groups.forEach((g) => {
        active += this.state[g].length;
        const pill = this.querySelector('[data-pill="' + g + '"]');
        if (pill) {
          pill.classList.toggle('is-active', this.state[g].length > 0);
          pill.querySelector('.nl-pill__n').textContent = this.state[g].length ? ' (' + this.state[g].length + ')' : '';
        }
        this.state[g].forEach((v) => {
          chips.push(
            '<button type="button" class="nl-chip" data-chip="' + v + '" data-chip-group="' + g + '">' +
              this.labelFor(g, v) +
              '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>'
          );
        });
      });
      const chipsEl = this.querySelector('[data-chips]');
      if (chipsEl) {
        chipsEl.innerHTML = chips.length
          ? chips.join('') + '<button type="button" class="nl-link-btn" data-clear>Clear all</button>'
          : '';
        chipsEl.hidden = chips.length === 0;
      }
      const badge = this.querySelector('[data-active-count]');
      if (badge) {
        badge.textContent = active;
        badge.hidden = active === 0;
      }
      this.syncInputs();
      this.writeUrl();
    }
  }
  customElements.define('nl-collection', NlCollection);
}
